var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.field.fieldType,_vm._b({tag:"component",style:(`${_vm.fieldCssVars(_vm.field)}`),attrs:{"data-field-id":_vm.field.fieldId,"fieldId":_vm.field.fieldId,"data-field-type":_vm.field.fieldType,"disabled":!_vm.canProceed},on:{"component-updated":_vm.updated}},'component',_vm.field.properties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }